module.exports = __webpack_public_path__ + "img/cps_preview_nl.14bbe51b.png";